const handleNav = (href: string) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function Footer() {
  return (
    <footer className="bg-[#1A1A1A] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-lg">
                <i className="ri-building-2-fill text-white text-xl"></i>
              </div>
              <div>
                <div className="font-black text-sm tracking-widest uppercase leading-tight text-white">Allen Construction</div>
                <div className="text-xs tracking-widest uppercase text-orange-400">Group</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-5">
              Premier construction services across the Dallas-Fort Worth metroplex. Licensed, insured, and committed to excellence on every project.
            </p>
            <a
              href="tel:6824502501"
              className="inline-flex items-center gap-2 text-orange-400 font-bold text-sm hover:text-orange-300 transition-colors cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill"></i>
              </div>
              (682) 450-2501
            </a>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-black text-sm uppercase tracking-widest text-white mb-5">Services</h4>
            <ul className="space-y-3">
              {['New Construction', 'Structural Framing', 'Concrete Foundations', 'Flatwork & Slabs', 'Full Remodeling', 'Room Additions'].map((s) => (
                <li key={s}>
                  <a
                    href="#services"
                    onClick={(e) => { e.preventDefault(); handleNav('#services'); }}
                    className="text-gray-400 text-sm hover:text-orange-400 transition-colors cursor-pointer"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-black text-sm uppercase tracking-widest text-white mb-5">Company</h4>
            <ul className="space-y-3">
              {[
                { label: 'About Us', href: '#about' },
                { label: 'Projects', href: '#projects' },
                { label: 'Testimonials', href: '#testimonials' },
                { label: 'Contact', href: '#contact' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                    className="text-gray-400 text-sm hover:text-orange-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-black text-sm uppercase tracking-widest text-white mb-5">Get In Touch</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-orange-400 text-sm"></i>
                </div>
                <div>
                  <div className="text-gray-400 text-xs mb-0.5">Phone</div>
                  <a href="tel:6824502501" className="text-white text-sm font-semibold hover:text-orange-400 transition-colors cursor-pointer">(682) 450-2501</a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-orange-400 text-sm"></i>
                </div>
                <div>
                  <div className="text-gray-400 text-xs mb-0.5">Service Area</div>
                  <div className="text-white text-sm font-semibold">DFW Metroplex</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-time-line text-orange-400 text-sm"></i>
                </div>
                <div>
                  <div className="text-gray-400 text-xs mb-0.5">Hours</div>
                  <div className="text-white text-sm font-semibold">Mon–Fri: 7AM–6PM</div>
                  <div className="text-gray-400 text-xs">Sat: 8AM–2PM</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-500 text-xs">
            &copy; 2025 Allen Construction Group. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-gray-600 text-xs">Licensed &amp; Insured | DFW, Texas</span>
            <a
              href="https://www.facebook.com/marketplace/profile/100034729634288/?ref=permalink&mibextid=dXMIcH"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center bg-white/10 hover:bg-orange-500 rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-facebook-fill text-white text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
